import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
const CargokingLogo = t0 => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("h-6 w-[22px]", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M11.1317 24C8.98004 24 7.05888 23.5256 5.36826 22.5768C3.6996 21.628 2.38224 20.2695 1.41617 18.5013C0.472056 16.7116 0 14.5553 0 12.0323C0 9.59569 0.4501 7.48248 1.3503 5.69272C2.27245 3.8814 3.57884 2.47978 5.26946 1.48787C6.96008 0.495957 8.94711 0 11.2305 0C14.3703 0 16.8074 0.754717 18.5419 2.26415C20.2984 3.77358 21.4291 5.9407 21.9341 8.7655L15.9731 8.99191C15.7315 7.61186 15.2046 6.53369 14.3922 5.75741C13.5798 4.98113 12.5259 4.59299 11.2305 4.59299C10.0888 4.59299 9.11178 4.90566 8.2994 5.531C7.50898 6.15633 6.90519 7.02965 6.48802 8.15094C6.09281 9.27224 5.89521 10.566 5.89521 12.0323C5.89521 13.5418 6.10379 14.8464 6.52096 15.9461C6.96008 17.0458 7.57485 17.8976 8.36527 18.5013C9.15569 19.1051 10.0998 19.407 11.1976 19.407C12.6247 19.407 13.7226 18.9973 14.491 18.1779C15.2814 17.3369 15.7864 16.1833 16.006 14.717L22 14.9434C21.6707 16.8625 21.0449 18.5013 20.1228 19.8598C19.2006 21.1968 17.993 22.221 16.5 22.9326C15.007 23.6442 13.2176 24 11.1317 24Z" data-sentry-element="path" data-sentry-source-file="organisation-logo.tsx" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <svg className={t1} fill="currentColor" viewBox="0 0 22 24" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="CargokingLogo" data-sentry-source-file="organisation-logo.tsx">{t2}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const InloadLogo = t0 => {
  const $ = _c(10);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("h-4 w-5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M0 16V0H4.61891V16H0Z" data-sentry-element="path" data-sentry-source-file="organisation-logo.tsx" />;
    t3 = <path d="M6.7538 16V3.87606H10.8418L11.0276 7.59437L10.4702 7.50423C10.5941 6.54272 10.8684 5.77653 11.2931 5.20563C11.7355 4.63474 12.2841 4.22911 12.9389 3.98873C13.5937 3.73333 14.3193 3.60563 15.1156 3.60563C16.1244 3.60563 16.9915 3.79343 17.7171 4.16901C18.4604 4.52958 19.0267 5.0554 19.416 5.74648C19.8053 6.42254 20 7.24131 20 8.20282V16H15.4342V9.53239C15.4342 8.91643 15.3811 8.39061 15.2749 7.95493C15.1687 7.51925 14.9741 7.18873 14.6909 6.96338C14.4254 6.73803 14.0361 6.62535 13.5229 6.62535C12.7796 6.62535 12.2222 6.88075 11.8505 7.39155C11.4966 7.88732 11.3196 8.60094 11.3196 9.53239V16H6.7538Z" data-sentry-element="path" data-sentry-source-file="organisation-logo.tsx" />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t1) {
    t4 = <svg className={t1} fill="currentColor" viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="InloadLogo" data-sentry-source-file="organisation-logo.tsx">{t2}{t3}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const KcharlesLogo = t0 => {
  const $ = _c(10);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-6", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M24 15.4012L21.565 19H9.71306L6.01719 15.3162C4.7563 14.0606 4.16925 13.4553 3.74965 12.973C3.76823 13.6232 3.80342 14.3136 3.80342 14.9828V19H0V5H3.80331V8.24407C3.80331 9.10238 3.76812 9.96069 3.73096 10.6936C4.20641 10.19 4.86571 9.47821 5.98199 8.41186L9.51249 5H15.0006L10.3166 9.01961C8.68783 10.4217 7.93956 11.0483 7.15194 11.5922C7.84643 12.136 8.79734 12.9116 10.3725 14.3751L11.4969 15.4014H24V15.4012Z" data-sentry-element="path" data-sentry-source-file="organisation-logo.tsx" />;
    t3 = <path d="M19.6113 5C15.3676 5 12.2381 7.76409 12.2381 11.8641C12.2381 12.7862 12.3993 13.6587 12.7011 14.4555H17.0274C16.399 13.8692 16.0249 13.0368 16.0249 12.0533C16.0249 10.0435 17.5628 8.64128 19.6113 8.64128H21.565L24 5H19.6113Z" data-sentry-element="path" data-sentry-source-file="organisation-logo.tsx" />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t1) {
    t4 = <svg className={t1} fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="KcharlesLogo" data-sentry-source-file="organisation-logo.tsx">{t2}{t3}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const ORGANISATION_LOGOS = {
  cargoking: CargokingLogo,
  inload: InloadLogo,
  'k-charles': KcharlesLogo
} as const;
const isOrganisationLogoSlug = (slug: string): slug is keyof typeof ORGANISATION_LOGOS => Object.hasOwn(ORGANISATION_LOGOS, slug);
export const getOrganisationLogo = (slug?: null | string) => slug && isOrganisationLogoSlug(slug) ? ORGANISATION_LOGOS[slug] : undefined;
export const OrganisationLogo = t0 => {
  const $ = _c(13);
  const {
    className,
    name,
    slug
  } = t0;
  const Logo = ORGANISATION_LOGOS[slug && isOrganisationLogoSlug(slug) ? slug : "cargoking"];
  let t1;
  if ($[0] !== className) {
    t1 = cn("shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Logo || $[3] !== t1) {
    t2 = <Logo className={t1} />;
    $[2] = Logo;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const logo = t2;
  if (!name) {
    return logo;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="inline-flex" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== logo) {
    t4 = <TooltipTrigger render={t3} data-sentry-element="TooltipTrigger" data-sentry-source-file="organisation-logo.tsx">{logo}</TooltipTrigger>;
    $[6] = logo;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== name) {
    t5 = <TooltipContent data-sentry-element="TooltipContent" data-sentry-source-file="organisation-logo.tsx">This company is synced with the {name} Xero accounting app.</TooltipContent>;
    $[8] = name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Tooltip data-sentry-element="Tooltip" data-sentry-component="OrganisationLogo" data-sentry-source-file="organisation-logo.tsx">{t4}{t5}</Tooltip>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};